import React, { useContext, useEffect, useState } from "react";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";

import GeneralContext from "../../context/GeneralContext/GeneralContext";
import api from "../../services/api";
import CustomToolbar from "../../components/grid/CustomToolbar";
import SL_Button from "../../components/buttons/Button";
import CreatePatient from "./CreatePatient";
import DetailPatient from "./DetailPatient";
import MangosHistory from "./MangosHistory";
import { Button, Modal, Popconfirm, Form, Input, Switch } from "antd";
import { UserAddOutlined, FileSearchOutlined } from "@ant-design/icons";
import PateintFilters from "./PatientFilters";
import patient_grid_columns from "./grid_columns/patient_grid_columns";
import HistoryPatient from "../../components/modals/HistoryPatient";
import { DateTime } from "luxon";
import { displayMessage } from "../../services/helper";
import EUsersTypes from "../../enums/EUsersTypes";
import { useNavigate } from "react-router-dom";
export default function ListPatient() {
  const { setShowLoading, windowHeight, mobile_mode, enums, setEnums, user } =
    useContext(GeneralContext);
  const [patient, setPatient] = useState([]);
  const [patientDeleteHistory, setPatientDeleteHistory] = useState([]);
  const [currentPatient, setCurrentPatient] = useState(null);
  const [currentPatientDeleteHistory, setCurrentPatientDeleteHistory] =
    useState(null);
  const [isModalCreatePatientVisible, setIsModalCreatePatientVisible] =
    useState(false);
  const [isModalDetailPatientVisible, setIsModalDetailPatientVisible] =
    useState(false);
  const [isModalSpendMangosVisible, setIsModalSpendMangosVisible] =
    useState(false);
  const [isModalGainMangosVisible, setIsModalGainMangosVisible] =
    useState(false);
  const [isModalMangosHistoryVisible, setIsModalMangosHistoryVisible] =
    useState(false);
  const [isModalHistoryPatientVisible, setIsModalHistoryPatientVisible] =
    useState(false);
  const [hasHistory, setHasHistory] = useState(false);
  const [isDentist, setIsDentist] = useState(false);

  const currentUserType = JSON.parse(localStorage.getItem("user"))?.user_type;
  const gridRef = useGridApiRef();
  const navigate = useNavigate();
  const DataGridProHeight = windowHeight * 0.7;

  useEffect(() => {
    loadPatientsData();
    loadPatientDeleteHistories();
    setIsDentist(user && user?.user_type == EUsersTypes.DENTIST.code);
  }, []);

  useEffect(() => {
    if (!enums) {
      setShowLoading(true);
      api.auth.getEnums().then((rs) => {
        setEnums(rs.data);
        setShowLoading(false);
      });
    }
  }, []);

  const loadPatientsData = async (currentFilters) => {
    try {
      setShowLoading(true);

      const payload = { ...currentFilters };
      const rs = await api.patient.list(payload);
      gridRef.current.setSelectionModel([]);
      setPatient(rs.data);
    } finally {
      setShowLoading(false);
    }
  };

  const loadPatientDeleteHistories = async () => {
    try {
      const rs = await api.patient_delete_history.list();
      setPatientDeleteHistory(rs.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleRowChange = (e) => {
    setCurrentPatient(e?.row);

    const patient_history_list = patientDeleteHistory.filter(
      (history) => e?.row.id === history.patient_id
    );
    setCurrentPatientDeleteHistory(patient_history_list);

    if (e.row?.PatientDeleteHistories.length > 0) {
      setHasHistory(true);
    } else {
      setHasHistory(false);
    }
  };

  const handleOnCloseModalCreatePatient = () => {
    setIsModalCreatePatientVisible(false);
  };

  const handleOnOpenModalCreatePatient = () => {
    setIsModalCreatePatientVisible(true);
  };

  const handleOnCloseModalDetailPatient = () => {
    setIsModalDetailPatientVisible(false);
  };

  const handleOnOpenModalDetailPatient = () => {
    setIsModalDetailPatientVisible(true);
  };

  const handleOnOpenModalHistoryPatient = () => {
    setIsModalHistoryPatientVisible(true);
  };

  const handleOnClickSendReport = (patient) => {
    setShowLoading(true);
    api.patient.sendReport(patient).then((rs) => {
      setShowLoading(false);
      alert(displayMessage("SEND_REPORT_SUCEES", [patient?.email]), "success");
    });
  };

  const handloOnClickSpendMangos = (patient) => {
    setCurrentPatient(patient);

    setIsModalSpendMangosVisible(true);
  };

  const handloOnClickGainMangos = (patient) => {
    setCurrentPatient(patient);

    setIsModalGainMangosVisible(true);
  };
  const handloOnClickOpenMangoHistory = (patient) => {
    setCurrentPatient(patient);

    setIsModalMangosHistoryVisible(true);
  };

  const handleOnCloseModalHistoryMangos = () => {
    setIsModalMangosHistoryVisible(false);
  };

  const handloOnClickExcludePatient = (patient) => {
    setShowLoading(true);

    api.patient.exclude(patient.id).then((res) => {
      setShowLoading(false);
      alert(
        displayMessage("REMOVE_PATIENT_SUCEES", [
          patient?.first_name,
          patient?.last_name,
        ])
      );
      loadPatientsData();
    });
  };

  const handloOnClickRecoverPatient = async (patient) => {
    setShowLoading(true);
    try {
      const payload = {
        ...patient,
        deletedAt: null,
        to_exclude: false,
        forced: true,
        user_id: user.id,
      };

      await api.patient.update(payload).then((res) => {
        alert(
          displayMessage("RECOVER_PATIENT_SUCEES", [
            patient?.first_name,
            patient?.last_name,
          ])
        );
      });
      await api.patient.toggleToExclude(patient.id);
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoading(false);
      loadPatientsData();
    }
  };

  const handleOnChangeToggle = async (patient) => {
    setShowLoading(true);
    try {
      await api.patient.toggleToExclude(patient.id).then((res) => {
        const full_name = `${patient?.first_name} ${
          patient?.last_name ? patient?.last_name : ""
        }`;
        alert(
          res.data.to_exclude
            ? displayMessage("WARNING_PATIENT_TO_EXCLUDE", [full_name])
            : displayMessage("WARNING_PATIENT_NOT_TO_EXCLUDE", [full_name]),
          res.data.to_exclude ? "warning" : "info"
        );
      });
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoading(false);
      loadPatientsData();
    }
  };

  const renderCustomToolBar = () => {
    return <CustomToolbar />;
  };

  const actionToExcludeToggle = {
    field: "to_exclude",
    headerName: displayMessage("MARK_TO_EXCLUDE"),
    width: 200,
    sortable: true,
    align: "center",
    renderCell: (params) => {
      return (
        <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
          <Switch
            checkedChildren={displayMessage("EXCLUDE")}
            unCheckedChildren={displayMessage("KEEP")}
            defaultChecked={params?.row?.to_exclude}
            onChange={() => handleOnChangeToggle(params?.row)}
            style={{
              display: "flex",
              flex: 1,
              maxWidth: 100,
              height: 30,
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      );
    },
    disableColumnSelector: true,
  };

  const toExcludeToggle = {
    field: "to_exclude",
    headerName: displayMessage("PATIENT_TO_EXCLUDE"),
    width: 200,
    sortable: true,
    align: "center",
    renderCell: (params) => {
      return (
        <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
          <Switch
            checkedChildren={displayMessage("EXCLUDE")}
            unCheckedChildren={displayMessage("KEEP")}
            defaultChecked={params?.row?.to_exclude}
            disabled={true}
            style={{
              display: "flex",
              flex: 1,
              maxWidth: 100,
              height: 30,
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      );
    },
    disableColumnSelector: true,
  };

  const actionDelete = {
    field: "action_exclude",
    headerName: displayMessage("DELETE_PATIENT"),
    width: 200,
    sortable: false,
    align: "center",
    renderCell: (params) => {
      return params.row.deletedAt ? (
        <Popconfirm
          zIndex={10001}
          placement="topLeft"
          title={displayMessage("COMFIRMATION_RECOVER_PATIENT")}
          disabled={params?.row?.deletedAt == null}
          onConfirm={() => handloOnClickRecoverPatient(params?.row)}
          okText={displayMessage("YES")}
          cancelText={displayMessage("NO")}
        >
          <Button type="primary" disabled={params?.row?.deletedAt == null}>
            {displayMessage("RECOVER_PATIENT")}
          </Button>
        </Popconfirm>
      ) : (
        <Popconfirm
          zIndex={10001}
          placement="topLeft"
          title={displayMessage("COMFIRMATION_EXCLUDE_PATIENT")}
          // disabled={params?.row?.deletedAt != null || !params?.row?.to_exclude} // Mark to exclude logic
          disabled={params?.row?.deletedAt != null}
          onConfirm={() => handloOnClickExcludePatient(params?.row)}
          okText={displayMessage("YES")}
          cancelText={displayMessage("NO")}
        >
          <Button
            type="primary"
            danger={true}
            // disabled={params?.row?.deletedAt != null || !params?.row?.to_exclude} // Mark to exclude logic
            disabled={params?.row?.deletedAt != null}
          >
            {displayMessage("DELETE_PATIENT")}
          </Button>
        </Popconfirm>
      );
    },
    disableColumnSelector: true,
  };

  const deletedAt = {
    field: "deletedAt",
    headerName: displayMessage("DELETED"),
    type: "date",
    width: 200,
    sortable: true,
    align: "center",
    valueFormatter: (params) => {
      if (!params?.value) {
        return params?.value;
      }
      const data = DateTime.fromISO(params.value);
      return data.toFormat("dd/MM/yyyy");
    },
    disableColumnSelector: true,
  };

  const SpendMangos = (props) => {
    const [form] = Form.useForm();

    const spendMangos = (payload) => {
      setShowLoading(true);

      payload.id = currentPatient.id;

      api.patient.spendMangos(payload).then((rs) => {
        setShowLoading(false);
        alert(displayMessage("MANGOS_UPDATED"), "success");
        setCurrentPatient(rs.data);
        loadPatientsData();
        setIsModalSpendMangosVisible(false);
      });
    };
    return (
      <Modal
        title={
          <div className="text-xl font-bold text-appian-blue">
            {displayMessage("SPEND_MANGOS_FOR", [
              currentPatient?.first_name,
              currentPatient?.last_name,
            ])}{" "}
          </div>
        }
        visible={isModalSpendMangosVisible}
        onCancel={() => setIsModalSpendMangosVisible(false)}
        centered={true}
        footer={[]}
        width={750}
        style={{ position: "relative" }}
        bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: "auto" }}
      >
        <Form
          form={form}
          className="w-full flex flex-col gap-2 p-5"
          onFinish={spendMangos}
          layout="vertical"
          requiredMark="optional"
        >
          <div style={{ marginTop: -16, marginBottom: 8 }}>
            <div style={{ fontWeight: "bold" }}>
              {displayMessage("MANGOS_ON_WALLET", [currentPatient?.mangos])}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: mobile_mode ? "column" : "row",
              gap: 4,
            }}
          >
            <Form.Item
              label={displayMessage("SPEND_AMOUNT")}
              name="mangos"
              className={`w-full flex`}
              style={{ flex: 1 }}
              rules={[
                {
                  required: true,
                  message: displayMessage("SPEND_AMOUNT_REQUIRED"),
                },
              ]}
            >
              <Input
                type="number"
                size="large"
                placeholder={displayMessage("HOW_MUCH")}
              />
            </Form.Item>

            <Form.Item
              label={displayMessage("SPEND_DESCRIPTION")}
              name="usage_description"
              className={`w-full flex`}
              style={{ flex: 3 }}
              rules={[
                {
                  required: true,
                  message: displayMessage("SPEND_DESCRIPTION_REQUIRED"),
                },
              ]}
            >
              <Input
                type="text"
                size="large"
                placeholder={displayMessage("WHAT_WAS_BOUGHT")}
              />
            </Form.Item>
          </div>

          <SL_Button
            type="primary"
            size="large"
            htmlType="submit"
            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
          >
            {displayMessage("SPEND_MANGOS")}
          </SL_Button>
        </Form>
      </Modal>
    );
  };

  const GainMangos = (props) => {
    const [form] = Form.useForm();

    const gainMangos = (payload) => {
      setShowLoading(true);

      payload.id = currentPatient.id;

      api.patient.gainMangos(payload).then((rs) => {
        setShowLoading(false);
        alert(displayMessage("MANGOS_UPDATED"), "success");
        setCurrentPatient(rs.data);
        loadPatientsData();
        setIsModalGainMangosVisible(false);
      });
    };
    return (
      <Modal
        title={
          <div className="text-xl font-bold text-appian-blue">
            {displayMessage("GIVE_MANGOS_FOR", [
              currentPatient?.first_name,
              currentPatient?.last_name,
            ])}{" "}
          </div>
        }
        visible={isModalGainMangosVisible}
        onCancel={() => setIsModalGainMangosVisible(false)}
        centered={true}
        footer={[]}
        width={750}
        style={{ position: "relative" }}
        bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: "auto" }}
      >
        <Form
          form={form}
          className="w-full flex flex-col gap-2 p-5"
          onFinish={gainMangos}
          layout="vertical"
          requiredMark="optional"
        >
          <div style={{ marginTop: -16, marginBottom: 8 }}>
            <div style={{ fontWeight: "bold" }}>
              {displayMessage("MANGOS_ON_WALLET", [currentPatient?.mangos])}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: mobile_mode ? "column" : "row",
              gap: 4,
            }}
          >
            <Form.Item
              label={displayMessage("GAIN_AMOUNT")}
              name="mangos"
              className={`w-full flex`}
              style={{ flex: 1 }}
              rules={[
                {
                  required: true,
                  message: displayMessage("GAIN_AMOUNT_REQUIRED"),
                },
              ]}
            >
              <Input
                type="number"
                size="large"
                placeholder={displayMessage("HOW_MUCH")}
              />
            </Form.Item>

            <Form.Item
              label={displayMessage("GAIN_DESCRIPTION")}
              name="usage_description"
              className={`w-full flex`}
              style={{ flex: 3 }}
              rules={[
                {
                  required: true,
                  message: displayMessage("GAIN_DESCRIPTION_REQUIRED"),
                },
              ]}
            >
              <Input
                type="text"
                size="large"
                placeholder={displayMessage("WHY_WAS_GAINED")}
              />
            </Form.Item>
          </div>

          <SL_Button
            type="primary"
            size="large"
            htmlType="submit"
            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
          >
            {displayMessage("GAIN_MANGOS")}
          </SL_Button>
        </Form>
      </Modal>
    );
  };

  return (
    <>
      {isModalCreatePatientVisible && (
        <CreatePatient
          isModalVisible={isModalCreatePatientVisible}
          handleOnCloseModal={handleOnCloseModalCreatePatient}
          refreshPatients={loadPatientsData}
        />
      )}

      {isModalDetailPatientVisible && (
        <DetailPatient
          isModalVisible={isModalDetailPatientVisible}
          handleOnCloseModal={handleOnCloseModalDetailPatient}
          patient_id={currentPatient.id}
          refreshPatients={loadPatientsData}
          handloOnClickSpendMangos={handloOnClickSpendMangos}
          handloOnClickGainMangos={handloOnClickGainMangos}
          handleOnClickSendReport={handleOnClickSendReport}
          handloOnClickOpenMangoHistory={handloOnClickOpenMangoHistory}
          currentPatient={currentPatient}
        />
      )}

      {isModalSpendMangosVisible && <SpendMangos />}

      {isModalGainMangosVisible && <GainMangos />}

      {isModalMangosHistoryVisible && (
        <MangosHistory
          handleOnCloseModalHistoryMangos={handleOnCloseModalHistoryMangos}
          currentPatient={currentPatient}
          isModalMangosHistoryVisible={isModalMangosHistoryVisible}
        />
      )}

      <PateintFilters handleOnSearchPatients={loadPatientsData} />
      <div className="flex flex-col w-full">
        <div style={{ height: DataGridProHeight, minHeight: 300 }}>
          <div
            className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${
              mobile_mode ? `flex-col` : `flex-row`
            } `}
          >
            <span className="self-center text-white flex-1 text-center font-medium">
              {displayMessage("PATIENT_LIST")}
            </span>
            <div
              className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`}
            >
              {(currentUserType === EUsersTypes.ADMIN.code ||
                currentUserType === EUsersTypes.DENTIST.code) && (
                <SL_Button
                  onClick={() =>
                    navigate("/patient-protocol", {
                      state: { patientId: currentPatient },
                    })
                  }
                  type="default"
                  disabled={!currentPatient || currentPatient.deletedAt}
                  className="items-center w-30 flex"
                  icon={<UserAddOutlined />}
                >
                  {displayMessage("ADD_PROTOCOL")}
                </SL_Button>
              )}

              <SL_Button
                type="default"
                className="items-center w-30 flex"
                disabled={!currentPatient || currentPatient.deletedAt}
                style={{
                  color: !currentPatient ? "grey" : null,
                  background: !currentPatient ? "lightgrey" : null,
                }}
                onClick={handleOnOpenModalDetailPatient}
                icon={<FileSearchOutlined />}
              >
                {displayMessage("DETAIL_PATIENT")}
              </SL_Button>
              <SL_Button
                type="default"
                className="items-center w-30 flex"
                disabled={!hasHistory}
                style={{
                  color: !hasHistory ? "grey" : null,
                  background: !hasHistory ? "lightgrey" : null,
                }}
                onClick={handleOnOpenModalHistoryPatient}
                icon={<FileSearchOutlined />}
              >
                {displayMessage("HISTORY_DELETED_RESTORED")}
              </SL_Button>
              <SL_Button
                type="default"
                className="items-center w-30 flex"
                onClick={handleOnOpenModalCreatePatient}
                icon={<UserAddOutlined />}
              >
                {displayMessage("CREATE_PATIENT")}
              </SL_Button>
            </div>
          </div>

          <DataGridPro
            rows={patient ?? []}
            apiRef={gridRef}
            style={{ height: "100%" }}
            columns={patient_grid_columns(enums, isDentist).concat(
              // Mark to exclude logic
              // currentUserType == enums?.EUserTypes?.ADMIN?.code ? [deletedAt, toExcludeToggle, actionDelete] : [],
              // currentUserType == enums?.EUserTypes?.DENTIST?.code ? [actionToExcludeToggle] : []
              [deletedAt, actionDelete]
            )}
            density={"comfortable"}
            pagination
            pageSize={100}
            components={{
              Toolbar: renderCustomToolBar,
            }}
            onRowClick={handleRowChange}
            disableMultipleSelection
          />

          <HistoryPatient
            currentPatientDeleteHistory={currentPatientDeleteHistory}
            isModalHistoryPatientVisible={isModalHistoryPatientVisible}
            setIsModalHistoryPatientVisible={setIsModalHistoryPatientVisible}
          />
        </div>
      </div>
    </>
  );
}
